import React from "react";
import { landingStyles } from "components/Landing/landingStyles";
import HeroBanner from "components/Marketing/Components/HeroBanner";
import Footer from "components/Footer";
import FeatureGrid from "./FeatureGrid";
import LogoConnection from "components/LogoConnection";
import { cellGrow } from "constants/styles";
import PATHS from "utils/paths";
import Link from "next/link";
import { isServer } from "utils/view";
import { magicCheckoutStyles } from "components/Landing/MagicCheckout/magicCheckoutStyles";
import Button from "components/Form/fields/Button";
import { BUTTON_TAGS } from "utils/constants/ui";

const MarketingAPILinks = () => {
  const tryButtonProps = {
    tag: BUTTON_TAGS.LINK,
    href: PATHS.SIGNUP,
    copy: "Sign up",
    classes: {
      button:
        "fw6 br2 pa3 border-box input-reset ba bg-transparent pointer f4 dib link items-center flex flex-shrink-0 cell-grow"
    }
  };
  const heroProps = {
    header: [
      {
        copy: "A powerful"
      },
      {
        classes: "color-primary underline",
        copy: "payment link"
      },
      {
        copy: "API built on Stripe checkout."
      }
    ],
    action: tryButtonProps,
    customClasses: {
      actions: "dib center pt3 flex flex-column items-center justify-center"
    },
    paddingBottom: 20,
    subheader:
      "The power of Stripe payment links, through a simple REST API. Sign up to get API access."
  };

  return (
    <div className="w-100 relative">
      <div className="mw8 center">
        <HeroBanner {...heroProps} />
        <div className="pb3">
          <Link href={PATHS.FEATURES_LINKS_BUILDER}>
            <div className="pointer cell-grow">
              <LogoConnection src="/assets/priceblocs_advancedLinksConnect.png" />
            </div>
          </Link>
        </div>
        <div className="pa3 pb5 flex flex-row">
          <FeatureGrid />
        </div>
      </div>
      <div className="w-100 before__image magic_checkout_link_bg relative">
        <div className="w-100 relative mw8 center pt5 pv5-l">
          <div className="w-100 flex items-center justify-center">
            <div className="flex flex-column justify-center">
              <div className="fw6 tc dib bg-white center f3 f2-l pb2 ph3 ph0-l">
                Get API Access
              </div>
              <div className="flex flex-row">
                <div className="tc dib bg-white center f5 pb2 lh-copy ph3 ph0-l">
                  Sign up to access your API keys.
                </div>
              </div>
            </div>
          </div>
          {!isServer() && (
            <div className="flex flex-column flex-row-ns items-center justify-center pt3">
              <div className="pb3 pb0-ns">
                <Button {...tryButtonProps} />
              </div>
            </div>
          )}
        </div>
        <div className="dib h3 h4-l"></div>
      </div>
      <div className="mw8 center">
        <div className="pt5 hairline-1 bt">
          <Footer />
        </div>
      </div>
      <style jsx>{landingStyles}</style>
      <style jsx>{magicCheckoutStyles}</style>
      <style jsx>{cellGrow}</style>
    </div>
  );
};

export default MarketingAPILinks;
